import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  HR_DOMAIN_INTRO,
  HR_GROUPS,
  HR_USE_CASES_SEO,
  HR_DOMAIN_FAQS,
  HR_ITEM_LIST_JSONLD,
  HR_BREADCRUMB_JSONLD,
  HR_WEBPAGE_JSONLD,
  HR_FAQ_JSONLD,
} from "../../data/rpa/hr-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = HR_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function HRRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? HR_GROUPS
      : HR_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={HR_DOMAIN_INTRO}
        domainSlug="hr-domain"
        basePath="/rpa-use-cases"
        useCaseCount={HR_USE_CASES_SEO.length}
        groupCount={HR_GROUPS.length}
        itemListJsonLd={HR_ITEM_LIST_JSONLD}
        faqJsonLd={HR_FAQ_JSONLD}
        breadcrumbJsonLd={HR_BREADCRUMB_JSONLD}
        webPageJsonLd={HR_WEBPAGE_JSONLD}
        keywords="HR Domain automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{HR_DOMAIN_INTRO.title}</h1>
          {HR_DOMAIN_INTRO.content ? <p>{HR_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={HR_USE_CASES_SEO}
        groups={HR_GROUPS}
        heading="HR Domain Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={HR_DOMAIN_INTRO.title}
        domainFaqs={HR_DOMAIN_FAQS}
        useCases={HR_USE_CASES_SEO}
      />
    </div>
  );
}

